import React, { Component } from "react";
import styled from "styled-components";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import NumberFormat from "react-number-format";
import { NO_NUM_FOUND, BUTTON_TEXT_OK } from "../../../text.js";

const AskForNumContainer = styled.div`
	width: 95%;
	margin: 0 auto;
`;

const InputNumContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-end;
`;

function NumberFormatCustom(props) {
	const { inputRef, onChange, ...other } = props;

	return (
		<NumberFormat
			{...other}
			getInputRef={inputRef}
			onValueChange={values => {
				onChange({
					target: {
						value: values.value
					}
				});
			}}
			type="tel"
			format="## ## ## ## ##"
		/>
	);
}

class AskForNum extends Component {
	constructor(props) {
		super(props);
		this.state = { num: "" };
	}

	handleChange = name => event => {
		this.setState({
			[name]: event.target.value
		});
	};

	searchForNum = () => {
		this.props.searchForNum(this.state.num);
	};

	render() {
		return (
			<AskForNumContainer>
				<Typography>{NO_NUM_FOUND}</Typography>
				<InputNumContainer>
					<TextField
						margin="normal"
						fullWidth
						label="Numéro de téléphone"
						value={this.state.num}
						onChange={this.handleChange("num")}
						InputProps={{
							inputComponent: NumberFormatCustom
						}}
					/>

					<Button
						style={{ marginLeft: "15px" }}
						variant="contained"
						onClick={this.searchForNum}
						color="primary"
					>
						{BUTTON_TEXT_OK}
					</Button>
				</InputNumContainer>
			</AskForNumContainer>
		);
	}
}

export default AskForNum;
